export default __webpack_public_path__ + "static/media/cover.bd747a9b.jpeg";